/**
 * Custom overrides: keep theme files untouched for easier updates.
 * PDP: transparent header blurs and sticky threshold after one viewport (not full gallery).
 */
(function () {
  const TRANSPARENT_CLASS = "wt-header--fashion-transparent";
  const SCROLL_THRESHOLD_PX = 80;

  function isPdpTransparentHeader() {
    const header = document.querySelector(".wt-header");
    return (
      document.body.classList.contains("template-product") &&
      header &&
      header.dataset.transparent &&
      header.classList.contains("wt-header--v3")
    );
  }

  function hasFashionGallery() {
    return document.querySelector("gallery-fashion .wt-product__gallery");
  }

  function updatePdpHeaderTransparent() {
    if (!isPdpTransparentHeader() || !hasFashionGallery()) return;
    const header = document.querySelector(".wt-header");
    if (!header) return;
    if (window.scrollY <= SCROLL_THRESHOLD_PX) {
      header.classList.add(TRANSPARENT_CLASS);
    } else {
      header.classList.remove(TRANSPARENT_CLASS);
    }
  }

  function setPdpStickyThresholdHeight() {
    if (!isPdpTransparentHeader()) return;
    if (!document.body.classList.contains("page-header-sticky")) return;
    const threshold = document.querySelector(".sticky-header__threshold");
    const gallery = document.querySelector("gallery-fashion");
    if (!threshold || !gallery) return;
    const masonry = gallery.querySelector(".swiper-wrapper--masonry");
    if (!masonry) return;
    const h = Math.min(masonry.offsetHeight, window.innerHeight);
    threshold.style.height = h + "px";
  }

  function initPdpHeaderOverrides() {
    if (!isPdpTransparentHeader() || !hasFashionGallery()) return;

    updatePdpHeaderTransparent();

    let scrollTicking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          setTimeout(updatePdpHeaderTransparent, 0);
          scrollTicking = false;
        });
      },
      { passive: true }
    );

    setTimeout(setPdpStickyThresholdHeight, 400);
    window.addEventListener("load", function () {
      setTimeout(setPdpStickyThresholdHeight, 300);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPdpHeaderOverrides);
  } else {
    initPdpHeaderOverrides();
  }
})();
